module.exports = __webpack_public_path__ + "static/media/metronome.4eda3787.svg";